import { Namespace } from '_core/utils/ssr';

export const customConfig = {
  i18nNamespaces: ['common', 'longtail', 'briefing', 'portfolio', 'explore', 'agency', 'stories', 'story'] as Namespace,
};
